import styled from 'styled-components';
import { AllieButton } from '../../../components/Buttons/Button';

import { AllieLink } from '../../../components/Buttons/Link';
import { AllieText } from '../../../components/Text';

const allieXlScreen = window
  .getComputedStyle(document.documentElement)
  .getPropertyValue('--allie-xl-screen');

export const StationSummaryStyled = styled.div`
  .divider {
    margin: 0 -24px;

    &.warning {
      border-top: 4px solid var(--allie-color-warning-main);
    }

    &.success {
      border-top: 4px solid var(--allie-color-success-main);
    }

    &.error {
      border-top: 4px solid var(--allie-color-error-main);
    }

    &.none {
      border-top: 4px solid var(--allie-color-light-50);
    }

    &.neutral {
      border-top: 4px solid var(--allie-color-neutral-50);
    }
  }

  .container {
    display: grid;
    row-gap: 24px;

    &-po-item {
      ion-item::part(native) {
        padding: 0;
      }
    }

    &-stats {
      display: grid;
      grid-template-columns: 1fr 1fr;
      row-gap: 24px;
      column-gap: 9px;

      &__item-label {
        margin-bottom: 4px;
      }

      &__stops-pattern {
        .label {
          margin-bottom: 16px;
        }
      }

      &__health {
        grid-column: 1 / -1;
        &__label {
          margin-bottom: 8px;
        }
        &__value {
          display: flex;
          column-gap: 8px;
          align-items: center;
        }
      }
    }
  }

  .station-card {
    border-radius: 16px;
  }

  .see-detail {
    height: 100%;
    --border-width: 1px !important;
    --border-radius: 8px !important;
    --border-color: var(--allie-color-neutral-30) !important;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 13px;
  align-items: center;
`;

export const IconContainer = styled.div`
  & path {
    color: var(--allie-color-neutral-40);
    fill: var(--allie-color-neutral-40);
  }
`;

export const FlexContainer = styled.div<{
  gap?: number;
  justifyContent?: string;
  alignItems?: string;
  flexDirection?: string;
}>`
  display: flex;
  flex-direction: ${(props) => (props.flexDirection ? props.flexDirection : 'row')};
  gap: ${(props) => (props.gap ? props.gap : '')}px;
  justify-content: ${(props) => (props.justifyContent ? props.justifyContent : '')};
  align-items: ${(props) => (props.alignItems ? props.alignItems : '')};
`;

export const SvgContainer = styled.data`
  svg {
    height: 100%;
  }
`;

export const StyledStationButton = styled(AllieButton)<{ isMobile?: boolean }>`
  button,
  ion-button {
    height: unset;

    button {
      height: unset;
    }
  }
`;

export const StatsStyledContainer = styled(FlexContainer)<{ isTablet: boolean }>`
  flex-grow: 1;
  > div:not(:last-child) {
    border-right: ${(props) => (props.isTablet ? '1px solid var(--allie-color-neutral-20)' : '')};
  }
`;

export const StyledStationTitleLink = styled(AllieLink)<{ isMobile?: boolean; isTablet?: boolean }>`
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
  font-size: ${(props) => (props.isMobile ? '16px' : '18px')};
  line-height: 26;
  font-weight: 600;
  color: var(--allie-color-neutral-main);
  flex: 1;
  min-width: 0;
  align-items: flex-start !important;
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  letter-spacing: 0;

  .button-native {
    justify-content: flex-start !important;
  }

  span {
    flex: 1;
    text-align: left;
    white-space: ${(props) => (props.isTablet ? 'break-spaces' : 'nowrap')};
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: normal;
  }
`;

export const StatsText = styled(AllieText)<{ collapsible?: boolean }>`
  ${(props) =>
    props.collapsible
      ? `
        max-width: 180px; 
        white-space: nowrap; 
        overflow: hidden; 
        text-overflow: ellipsis; 
        @media (max-width: 800px) { 
          max-width: 80px !important; 
        }; 
        @media (max-width: 1200px) { 
          max-width: 130px !important; 
        }
      `
      : ''}
  @media (min-width: ${allieXlScreen}) {
    font-size: 14px !important;
  }
`;

export const StyledOperationalStatus = styled.div`
  display: inline-block;
  ion-chip {
    margin: 0 !important;
  }
`;
